import React from 'react';
import {useTranslation} from 'react-i18next';
import {useRulesStore} from '../rules.store';
import SectionWrapper from './section-wrapper';
import DataTable from './data-table';

const CommissionRateTable: React.FC = () => {
  const {t} = useTranslation();
  const {commissionData} = useRulesStore();

  // 三张表统一列配置
  const columns = [
    {key: 'rebateForBets', title: t('agent.rules.tableHeaders.rebateForBets')},
    {key: 'teamLevel1', title: t('agent.rules.tableHeaders.teamLevel1')},
    {key: 'teamLevel2', title: t('agent.rules.tableHeaders.teamLevel2')},
    {key: 'teamLevel3', title: t('agent.rules.tableHeaders.teamLevel3')},
    {key: 'teamLevel4', title: t('agent.rules.tableHeaders.teamLevel4')},
  ];

  return (
    <SectionWrapper title={t('agent.rules.commissionRate.title')}>
      {/* Sport Rebates 表格 */}
      <div className="space-y-2">
        <h3 className="text-sm font-medium text-t2">
          {t('agent.rules.sectionTitles.sportRebates')}
        </h3>
        <DataTable columns={columns} data={commissionData.sportsRebates} />
      </div>

      {/* Casino Rebates 表格 */}
      <div className="space-y-2">
        <h3 className="text-sm font-medium text-t2">
          {t('agent.rules.sectionTitles.casinoRebates')}
        </h3>
        <DataTable columns={columns} data={commissionData.casinoRebates} />
      </div>

      {/* Lottery Rebates 表格 */}
      <div className="space-y-2">
        <h3 className="text-sm font-medium text-t2">
          {t('agent.rules.sectionTitles.lotteryRebates')}
        </h3>
        <DataTable columns={columns} data={commissionData.lotteryRebates} />
      </div>

      {/* 底部说明 */}
      <div className="bg-bg rounded-lg p-2.5">
        <p className="text-xs text-[rgba(0,0,0,0.8)] leading-normal">
          {t('agent.rules.commissionRate.note')}
        </p>
      </div>
    </SectionWrapper>
  );
};

export default CommissionRateTable;
